/* eslint-disable no-unused-vars */
import React from 'react';

import classnames from 'classnames';

import styles from './PredefinedButtons.module.scss';
import Button from '../Button';
import CloseIcon from '../Icon/CloseIcon';

export const CloseButtonVariants = {
  DEFAULT: 'default',
  WHITE: 'white',
};

interface CloseButtonProps {
  variant?: string;
  onClick(...args: unknown[]): unknown;
  className?: string;
}

const CloseButton = ({ className, onClick, variant }: CloseButtonProps) => {
  const iconClasses = classnames({
    [styles.greyFill]: variant === CloseButtonVariants.WHITE,
  });
  const classes = classnames(styles.circle, className, {
    [styles.transparentBackground]: variant === CloseButtonVariants.DEFAULT,
    [styles.whiteBackground]: variant === CloseButtonVariants.WHITE,
  });
  return (
    <Button className={classes} onClick={onClick} aria-label="Close">
      <CloseIcon className={iconClasses} />
    </Button>
  );
};

export default CloseButton;
